import { useSalidaStore } from "@/store/useSalidaStore";
import { turnoDeHora } from "@/utils/turno";

// 'YYYY-MM-DD' en hora local (evita el corrimiento UTC de toISOString)
const fechaYMD = (date) => {
  const d = date instanceof Date ? date : new Date(date);
  if (isNaN(d)) return null;
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
};

export const useTurnoSalida = () => {
  const salida = useSalidaStore();

  // Busca la salida con hora fijada más relevante para un territorio, dada la
  // fecha en que se está informando el trabajo. Preferencia: misma fecha
  // (calendario) que el informe; si no hay, la salida pasada más reciente.
  const buscarTurnoSalida = (territorioKey, fechaInforme) => {
    if (!territorioKey) return null;

    const candidatas = [...(salida.list.data || []), ...(salida.history || [])].filter(
      (s) => Array.isArray(s.territorios) && s.territorios.includes(territorioKey) && s.hour
    );
    if (!candidatas.length) return null;

    const ymdInforme = fechaYMD(fechaInforme);
    const mismaFecha = candidatas.find((s) => fechaYMD(s.date) === ymdInforme);

    const elegida =
      mismaFecha ||
      [...candidatas]
        .filter((s) => new Date(s.date).getTime() <= new Date(fechaInforme).getTime())
        .sort((a, b) => new Date(b.date) - new Date(a.date))[0];

    if (!elegida) return null;
    return { hour: elegida.hour, turno: turnoDeHora(elegida.hour) };
  };

  return { buscarTurnoSalida };
};
